// 引入手机号极验
import Vue from 'vue'
require('~/assets/js/geetest')
Vue.prototype.$initGeet = initGeetest // eslint-disable-line
